import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CapabilitiesService {
  private readonly capabilities = signal<Record<string, boolean>>({});

  constructor(private http: HttpClient) {}

  /**
   * Caricata una volta all'avvio. In caso di errore la mappa resta vuota e
   * ogni comando risulta negato: meglio un pulsante mancante di un'operazione
   * che il backend rifiuta.
   */
  load(): Observable<Record<string, boolean>> {
    return this.http.get<Record<string, boolean>>('api/capabilities').pipe(
      tap(capabilities => this.capabilities.set(capabilities ?? {})),
      catchError(error => {
        console.error('Errore caricamento capabilities', error);
        this.capabilities.set({});
        return of({});
      }),
    );
  }

  can(capability: string): boolean {
    return this.capabilities()[capability] === true;
  }
}
